// Types
import type { ChangeEvent, Dispatch, MutableRefObject, SetStateAction } from 'react';
import { useRef } from 'react';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import Icon from '@/components/base/Icon';
import Input from '@/components/base/Input';

type AlbumsSearchProps = {
    cancelTokenRef: MutableRefObject<AbortController>;
    setAlbumSearch: Dispatch<SetStateAction<string>>;
};

const AlbumsSearch = ({ cancelTokenRef, setAlbumSearch }: AlbumsSearchProps) => {
    const timeoutRef = useRef<NodeJS.Timeout>(null);
    const { t } = useTranslation('content');

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (typeof timeoutRef.current !== typeof undefined) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            if (typeof cancelTokenRef.current !== typeof undefined) {
                cancelTokenRef?.current?.abort();
            }
            cancelTokenRef.current = new AbortController();
            const value = e.target.value.trim();
            setAlbumSearch(value || undefined);
        }, 350);

        return () => clearTimeout(timeoutRef.current);
    };

    return (
        <div className="mb-5 max-w-52">
            <Input
                inputStyle="small_rounded_no_background"
                data-testid="albums-search-input"
                placeholder={t('search_album')}
                beforeInput={<Icon icon="search" />}
                onChange={handleChange}
            />
        </div>
    );
};

export default AlbumsSearch;
